import request from './request'

// 查询上架中活动
export function getOnShelfActivity(params: any) {
    return request.get('/rest/sys/activity/getOnShelfActivity', { params })
}
// 查询活动详情接口
export function getActivityDetail(params: any) {
    return request.get('/rest/sys/activity/getActivityDetail', { params })
}
